<div *ngIf="loadingService.isVisible() | async" class="spiner-overlay d-flex justify-content-center">
    <div class="spinner-icon spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>